export default __webpack_public_path__ + "static/9_months-baedb1d19d5d51441810bbd6dff2caa6.jpeg";